var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.112C0 4.71613 4.97455 0 11.758 0C18.5415 0 23.5161 4.69459 23.5161 11.112C23.5161 17.5294 18.4984 22.224 11.758 22.224C5.01762 22.224 0 17.4863 0 11.112ZM18.4984 11.112C18.4984 7.02036 15.6128 4.22083 11.7796 4.22083C7.94636 4.22083 5.06069 7.02036 5.06069 11.112C5.06069 15.2036 7.94636 18.0031 11.7796 18.0031C15.6128 18.0031 18.4984 15.2036 18.4984 11.112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOWhite);
export default __webpack_public_path__ + "static/media/o-white.d3c30f195ef741b4bd378942eb347b9e.svg";
export { ForwardRef as ReactComponent };